import { questionsStrings as S } from './strings'

export const EMPTY_QUESTION = {
  text: '',
  option1: '',
  option2: '',
  option3: '',
  option4: '',
  /* The English half. The legacy asks for the whole question twice — a question
     that only exists in Arabic cannot be sat by anyone using the English panel,
     and the exam still counts it. */
  textEn: '',
  option1En: '',
  option2En: '',
  option3En: '',
  option4En: '',
  imageAr: null,
  imageEn: null,
  answer: '',
  difficulty: '',
  category: '',
}

/**
 * What a question cannot be saved without — the server's own rules, mirrored so the
 * form refuses before it posts.
 *
 * @param {boolean} askTopic  the form is the one that has to ASK which topic — the
 *   standalone bank. Inside a topic the answer is already known.
 */
export function validateQuestion(values, { askTopic }) {
  const found = {}
  if (!values.text.trim()) found.text = S.form.required
  if (!values.option1.trim()) found.option1 = S.form.required
  if (!values.option2.trim()) found.option2 = S.form.required
  if (!values.textEn.trim()) found.textEn = S.form.required
  if (!values.option1En.trim()) found.option1En = S.form.required
  if (!values.option2En.trim()) found.option2En = S.form.required
  if (!values.answer) found.answer = S.form.required
  /* THE TOPIC IS REQUIRED BY THE DATABASE, not just by the form. Without it the handler
     parses an empty `CategoryId` to 0 and the insert violates the foreign key — and what
     the administrator was shown was the raw EF message, "An error occurred while saving
     the entity changes. See the inner exception for details." */
  if (askTopic && !values.category) found.category = S.form.required
  /* THE DIFFICULTY IS REQUIRED BY THE SERVER TOO: an unpicked level went up as 0, which
     `ValidateQuestion` reads as empty and refuses. */
  if (!values.difficulty) found.difficulty = S.form.required
  return found
}
